import React, { ReactNode } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';
import { InfluencerHeroDesktop } from '~/features/Influencer/InfluencerHeroDesktop';
import { InfluencerHeroDesktopWhilePlaying } from '~/features/Influencer/InfluencerHeroDesktopWhilePlaying';
import { InfluencerHeroMobile } from '~/features/Influencer/InfluencerHeroMobile';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advanced);

export function InfluencerHero(props: {
  src: string;
  influencerName: string;
  nextLive: string | null;
  hasEnded: boolean;
  children?: ReactNode;
  isStreamChosen: boolean;
  videoIsLive: boolean;
}) {
  return (
    <>
      {/* MOBILE */}
      {!props.isStreamChosen && (
        <InfluencerHeroMobile
          src={props.src}
          alt={props.influencerName}
          hasEnded={props.hasEnded}
          nextLive={props.nextLive}
        />
      )}

      {/* DESKTOP */}
      {props.isStreamChosen ? (
        <InfluencerHeroDesktopWhilePlaying
          src={props.src}
          alt={props.influencerName}
          videoIsLive={props.videoIsLive}
        />
      ) : (
        <InfluencerHeroDesktop
          src={props.src}
          alt={props.influencerName}
          nextLive={props.nextLive}
          hasEnded={props.hasEnded}
        >
          {props.children}
        </InfluencerHeroDesktop>
      )}
    </>
  );
}
